import { render, staticRenderFns } from "./ProductDetailEditor.vue?vue&type=template&id=352ec5ec&"
import script from "./ProductDetailEditor.vue?vue&type=script&lang=js&"
export * from "./ProductDetailEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports